<template>
  <div id="app">

    <div class="" style="width: 130px;margin: 32px auto 0 auto;">
      <img src="../assets/images/m_logo.png" style="width: 100%;"/>
    </div>

    <div style="text-align: center;color: #949494;font-size: 14px;transform: translateY(-10px)">自动化产品视频拍摄</div>



    <div style="position: relative;padding-bottom: 56.11%;font-size: 0;margin-top: 26px;">
    <div style="position: absolute;left: 0; right: 0;bottom: 0;top: 0;">
      <video style="width: 100%!important; height: 100% !important;;"
          id="bannerVideo"
          class="video-js vjs-default-skin vjs-big-play-centered"
          controls

          poster="https://www.bunande.com/shoot/f.jpg">
        <source src="https://www.bunande.com/media/banner.mp4" type="video/mp4" >
      </video>
    </div>
    </div>

    <div style="margin-bottom: 24px;">
      <div style="text-align: center;line-height: 56px;"><span style="font-weight: bold;font-size: 22px;color: #000000;">短视频</span><span style="font-size: 20px;color: #ED4F20;font-weight: bold">399</span><span style="font-weight: bold;font-size: 18px;">元/条</span></div>

      <div class="cus-row" style="margin-top: 12px;">
        <div class="cus-row-col-3"><span class="ser_text">自动化机械拍摄</span></div>
        <div class="cus-row-col-3"><span class="ser_text">免费提供脚本</span></div>
        <div class="cus-row-col-3"><span class="ser_text">免费修改正片1次</span></div>
        <div class="cus-row-col-3"><span class="ser_text">最快一天交片</span></div>

      </div>
    </div>

    <div style="background-color: #ececec;">

    <div style="padding-top: 32px;font-size: 16px;font-weight: bold;color: rgb(242, 84, 34)">样片赏析</div>


    <div style="padding: 0 12px;margin-top: 32px;" >
<!--      <img style="width: 100%;"/>-->


      <div class="video-item">
        <div style="position: relative;padding-bottom: 56%;font-size: 0;">
        <video
            style="width: 100% !important;height: 100% !important;position: absolute;top:0;left: 0;right: 0;bottom: 0;"
            class="video-js vjs-default-skin vjs-big-play-centered"
            controls
            poster="https://www.bunande.com/shoot/2.jpg"
            >
          <source src="https://www.bunande.com/media/4.20切菜板&不难得.mp4" type="video/mp4" >
        </video>
        </div>

        <div class="cus-row cus-row-v-m" style="padding: 20px 12px;background-color: #f1f1f1">
          <div class="cus-row-col-8 t-al-l" style="font-size: 16px; color: #949494;">切菜板</div>
          <div class="cus-row-col-4 t-al-r" style="font-size: 16px; color: #949494;">
            <img src="https://www.bunande.com/boot/public/images/eyes.png" style="margin-right: 6px;" class="in-bl-v-m"> 9945
          </div>
        </div>
      </div>


      <div class="video-item">
        <div style="position: relative;padding-bottom: 56%;font-size: 0;">
          <video
              style="width: 100% !important;height: 100% !important;position: absolute;top:0;left: 0;right: 0;bottom: 0;"
              class="video-js vjs-default-skin vjs-big-play-centered"
              controls
              preload="auto"
              poster="https://www.bunande.com/shoot/4.jpg"
              >
            <source src="https://www.bunande.com/media/4.20化妆刷&不难得.mp4" type="video/mp4" >
          </video>
        </div>

        <div class="cus-row cus-row-v-m" style="padding: 20px 12px;background-color: #f1f1f1">
          <div class="cus-row-col-8 t-al-l" style="font-size: 16px; color: #949494;">化妆刷</div>
          <div class="cus-row-col-4 t-al-r" style="font-size: 16px; color: #949494;">
            <img src="https://www.bunande.com/boot/public/images/eyes.png" style="margin-right: 6px;" class="in-bl-v-m"> 9945
          </div>
        </div>
      </div>



      <div class="video-item">
        <div style="position: relative;padding-bottom: 56%;font-size: 0;">
          <video
              style="width: 100% !important;height: 100% !important;position: absolute;top:0;left: 0;right: 0;bottom: 0;"
              class="video-js vjs-default-skin vjs-big-play-centered"
              controls
              poster="https://www.bunande.com/shoot/3.jpg"
              >
            <source src="https://www.bunande.com/media/4.20录音笔&不难得.mp4" type="video/mp4" >
          </video>
        </div>

        <div class="cus-row cus-row-v-m" style="padding: 20px 12px;background-color: #f1f1f1">
          <div class="cus-row-col-8 t-al-l" style="font-size: 16px; color: #949494;">录音笔</div>
          <div class="cus-row-col-4 t-al-r" style="font-size: 16px; color: #949494;">
            <img src="https://www.bunande.com/boot/public/images/eyes.png" style="margin-right: 6px;" class="in-bl-v-m"> 9945
          </div>
        </div>
      </div>


      <div class="video-item">
        <div style="position: relative;padding-bottom: 56%;font-size: 0;">
          <video
              style="width: 100% !important;height: 100% !important;position: absolute;top:0;left: 0;right: 0;bottom: 0;"
              class="video-js vjs-default-skin vjs-big-play-centered"
              controls

              poster="https://www.bunande.com/shoot/5.jpg"
              >
            <source src="https://www.bunande.com/media/4.20录音笔2&不难得.mp4" type="video/mp4" >
          </video>
        </div>

        <div class="cus-row cus-row-v-m" style="padding: 20px 12px;background-color: #f1f1f1">
          <div class="cus-row-col-8 t-al-l" style="font-size: 16px; color: #949494;">录音笔2</div>
          <div class="cus-row-col-4 t-al-r" style="font-size: 16px; color: #949494;">
            <img src="https://www.bunande.com/boot/public/images/eyes.png" style="margin-right: 6px;" class="in-bl-v-m"> 9945
          </div>
        </div>
      </div>



      <div class="video-item">
        <div style="position: relative;padding-bottom: 56%;font-size: 0;">
          <video
              style="width: 100% !important;height: 100% !important;position: absolute;top:0;left: 0;right: 0;bottom: 0;"
              class="video-js vjs-default-skin vjs-big-play-centered"
              controls

              poster="https://www.bunande.com/shoot/6.jpg"
          >
            <source src="https://www.bunande.com/media/4.20彩色樱花筷&不难得.mp4" type="video/mp4" >
          </video>
        </div>

        <div class="cus-row cus-row-v-m" style="padding: 20px 12px;background-color: #f1f1f1">
          <div class="cus-row-col-8 t-al-l" style="font-size: 16px; color: #949494;">彩色樱花筷</div>
          <div class="cus-row-col-4 t-al-r" style="font-size: 16px; color: #949494;">
            <img src="https://www.bunande.com/boot/public/images/eyes.png" style="margin-right: 6px;" class="in-bl-v-m"> 9945
          </div>
        </div>
      </div>


      <div class="video-item">
        <div style="position: relative;padding-bottom: 56%;font-size: 0;">
          <video
              style="width: 100% !important;height: 100% !important;position: absolute;top:0;left: 0;right: 0;bottom: 0;"
              class="video-js vjs-default-skin vjs-big-play-centered"
              controls

              poster="https://www.bunande.com/shoot/7.jpg"
           >
            <source src="https://www.bunande.com/media/4.20美妆镜&不难得.mp4" type="video/mp4" >
          </video>
        </div>

        <div class="cus-row cus-row-v-m" style="padding: 20px 12px;background-color: #f1f1f1">
          <div class="cus-row-col-8 t-al-l" style="font-size: 16px; color: #949494;">美妆镜</div>
          <div class="cus-row-col-4 t-al-r" style="font-size: 16px; color: #949494;">
            <img src="https://www.bunande.com/boot/public/images/eyes.png" style="margin-right: 6px;" class="in-bl-v-m"> 9945
          </div>
        </div>
      </div>



      <div class="video-item">
        <div style="position: relative;padding-bottom: 56%;font-size: 0;">
          <video
              style="width: 100% !important;height: 100% !important;position: absolute;top:0;left: 0;right: 0;bottom: 0;"
              class="video-js vjs-default-skin vjs-big-play-centered"
              controls

              poster="https://www.bunande.com/shoot/8.jpg"
             >
            <source src="https://www.bunande.com/media/4.20耳机&不难得.mp4" type="video/mp4" >
          </video>
        </div>

        <div class="cus-row cus-row-v-m" style="padding: 20px 12px;background-color: #f1f1f1">
          <div class="cus-row-col-8 t-al-l" style="font-size: 16px; color: #949494;">耳机</div>
          <div class="cus-row-col-4 t-al-r" style="font-size: 16px; color: #949494;">
            <img src="https://www.bunande.com/boot/public/images/eyes.png" style="margin-right: 6px;" class="in-bl-v-m"> 9945
          </div>
        </div>
      </div>



      <div class="video-item">
        <div style="position: relative;padding-bottom: 56%;font-size: 0;">
          <video
              style="width: 100% !important;height: 100% !important;position: absolute;top:0;left: 0;right: 0;bottom: 0;"
              class="video-js vjs-default-skin vjs-big-play-centered"
              controls

              poster="https://www.bunande.com/shoot/1.jpg"
            >
            <source src="https://www.bunande.com/media/4.20耳机pbt001&不难得.mp4" type="video/mp4" >
          </video>
        </div>

        <div class="cus-row cus-row-v-m" style="padding: 20px 12px;background-color: #f1f1f1">
          <div class="cus-row-col-8 t-al-l" style="font-size: 16px; color: #949494;">耳机pbt001</div>
          <div class="cus-row-col-4 t-al-r" style="font-size: 16px; color: #949494;">
            <img src="https://www.bunande.com/boot/public/images/eyes.png" style="margin-right: 6px;" class="in-bl-v-m"> 9945
          </div>
        </div>
      </div>


      <div class="video-item">
        <div style="position: relative;padding-bottom: 56%;font-size: 0;">
          <video
              style="width: 100% !important;height: 100% !important;position: absolute;top:0;left: 0;right: 0;bottom: 0;"
              class="video-js vjs-default-skin vjs-big-play-centered"
              controls
              poster="https://www.bunande.com/shoot/9.jpg"
              >
            <source src="https://www.bunande.com/media/4.20耳机pbt003&不难得.mp4" type="video/mp4" >
          </video>
        </div>

        <div class="cus-row cus-row-v-m" style="padding: 20px 12px;background-color: #f1f1f1">
          <div class="cus-row-col-8 t-al-l" style="font-size: 16px; color: #949494;">耳机pbt003</div>
          <div class="cus-row-col-4 t-al-r" style="font-size: 16px; color: #949494;">
            <img src="https://www.bunande.com/boot/public/images/eyes.png" style="margin-right: 6px;" class="in-bl-v-m"> 9945
          </div>
        </div>
      </div>


      <div class="video-item">
        <div style="position: relative;padding-bottom: 56%;font-size: 0;">
          <video
              style="width: 100% !important;height: 100% !important;position: absolute;top:0;left: 0;right: 0;bottom: 0;"
              class="video-js vjs-default-skin vjs-big-play-centered"
              controls

       >
            <source src="https://www.bunande.com/media/4.20表壳&不难得.mp4" type="video/mp4" >
          </video>
        </div>

        <div class="cus-row cus-row-v-m" style="padding: 20px 12px;background-color: #f1f1f1">
          <div class="cus-row-col-8 t-al-l" style="font-size: 16px; color: #949494;">表壳</div>
          <div class="cus-row-col-4 t-al-r" style="font-size: 16px; color: #949494;">
            <img src="https://www.bunande.com/boot/public/images/eyes.png" style="margin-right: 6px;" class="in-bl-v-m"> 9945
          </div>
        </div>
      </div>



      <div class="video-item">
        <div style="position: relative;padding-bottom: 56%;font-size: 0;">
          <video
              style="width: 100% !important;height: 100% !important;position: absolute;top:0;left: 0;right: 0;bottom: 0;"
              class="video-js vjs-default-skin vjs-big-play-centered"
              controls
              poster="https://www.bunande.com/shoot/11.jpg"

         >
            <source src="https://www.bunande.com/media/4.20键盘&不难得.mp4" type="video/mp4" >
          </video>
        </div>

        <div class="cus-row cus-row-v-m" style="padding: 20px 12px;background-color: #f1f1f1">
          <div class="cus-row-col-8 t-al-l" style="font-size: 16px; color: #949494;">键盘</div>
          <div class="cus-row-col-4 t-al-r" style="font-size: 16px; color: #949494;">
            <img src="https://www.bunande.com/boot/public/images/eyes.png" style="margin-right: 6px;" class="in-bl-v-m"> 9945
          </div>
        </div>
      </div>


      <div class="video-item">
        <div style="position: relative;padding-bottom: 56%;font-size: 0;">
          <video
              style="width: 100% !important;height: 100% !important;position: absolute;top:0;left: 0;right: 0;bottom: 0;"
              class="video-js vjs-default-skin vjs-big-play-centered"
              controls
              poster="https://www.bunande.com/shoot/12.jpg"
           >
            <source src="https://www.bunande.com/media/4.20键盘2&不难得.mp4" type="video/mp4" >
          </video>
        </div>

        <div class="cus-row cus-row-v-m" style="padding: 20px 12px;background-color: #f1f1f1">
          <div class="cus-row-col-8 t-al-l" style="font-size: 16px; color: #949494;">键盘2</div>
          <div class="cus-row-col-4 t-al-r" style="font-size: 16px; color: #949494;">
            <img src="https://www.bunande.com/boot/public/images/eyes.png" style="margin-right: 6px;" class="in-bl-v-m"> 9945
          </div>
        </div>
      </div>


      <div class="video-item">
        <div style="position: relative;padding-bottom: 56%;font-size: 0;">
          <video
              style="width: 100% !important;height: 100% !important;position: absolute;top:0;left: 0;right: 0;bottom: 0;"
              class="video-js vjs-default-skin vjs-big-play-centered"
              controls
              poster="https://www.bunande.com/shoot/13.jpg"
             >
            <source src="https://www.bunande.com/media/4.20键盘套&不难得.mp4" type="video/mp4" >
          </video>
        </div>

        <div class="cus-row cus-row-v-m" style="padding: 20px 12px;background-color: #f1f1f1">
          <div class="cus-row-col-8 t-al-l" style="font-size: 16px; color: #949494;">键盘套</div>
          <div class="cus-row-col-4 t-al-r" style="font-size: 16px; color: #949494;">
            <img src="https://www.bunande.com/boot/public/images/eyes.png" style="margin-right: 6px;" class="in-bl-v-m"> 9945
          </div>
        </div>
      </div>


      <div class="video-item">
        <div style="position: relative;padding-bottom: 56%;font-size: 0;">
          <video
              style="width: 100% !important;height: 100% !important;position: absolute;top:0;left: 0;right: 0;bottom: 0;"
              class="video-js vjs-default-skin vjs-big-play-centered"
              controls
              poster="https://www.bunande.com/shoot/14.jpg"
            >
            <source src="https://www.bunande.com/media/4.20香氛&不难得.mp4" type="video/mp4" >
          </video>
        </div>

        <div class="cus-row cus-row-v-m" style="padding: 20px 12px;background-color: #f1f1f1">
          <div class="cus-row-col-8 t-al-l" style="font-size: 16px; color: #949494;">香氛</div>
          <div class="cus-row-col-4 t-al-r" style="font-size: 16px; color: #949494;">
            <img src="https://www.bunande.com/boot/public/images/eyes.png" style="margin-right: 6px;" class="in-bl-v-m"> 9945
          </div>
        </div>
      </div>


      <div class="video-item">
        <div style="position: relative;padding-bottom: 56%;font-size: 0;">
          <video
              style="width: 100% !important;height: 100% !important;position: absolute;top:0;left: 0;right: 0;bottom: 0;"
              class="video-js vjs-default-skin vjs-big-play-centered"
              controls
              poster="https://www.bunande.com/shoot/15.jpg"
             >
            <source src="https://www.bunande.com/media/4.20香水&不难得.mp4" type="video/mp4" >
          </video>
        </div>

        <div class="cus-row cus-row-v-m" style="padding: 20px 12px;background-color: #f1f1f1">
          <div class="cus-row-col-8 t-al-l" style="font-size: 16px; color: #949494;">香水</div>
          <div class="cus-row-col-4 t-al-r" style="font-size: 16px; color: #949494;">
            <img src="https://www.bunande.com/boot/public/images/eyes.png" style="margin-right: 6px;" class="in-bl-v-m"> 9945
          </div>
        </div>
      </div>



      <div class="video-item">
        <div style="position: relative;padding-bottom: 56%;font-size: 0;">
          <video
              style="width: 100% !important;height: 100% !important;position: absolute;top:0;left: 0;right: 0;bottom: 0;"
              class="video-js vjs-default-skin vjs-big-play-centered"
              controls
              poster="https://www.bunande.com/shoot/16.jpg"
          >
            <source src="https://www.bunande.com/media/耳机.mp4" type="video/mp4" >
          </video>
        </div>

        <div class="cus-row cus-row-v-m" style="padding: 20px 12px;background-color: #f1f1f1">
          <div class="cus-row-col-8 t-al-l" style="font-size: 16px; color: #949494;">耳机</div>
          <div class="cus-row-col-4 t-al-r" style="font-size: 16px; color: #949494;">
            <img src="https://www.bunande.com/boot/public/images/eyes.png" style="margin-right: 6px;" class="in-bl-v-m"> 9945
          </div>
        </div>
      </div>



      <div style="margin-bottom: 84px;"></div>


    </div>


    </div>
    </div>
</template>


<script>
import common from '../assets/js/common'
import NewsList from '../components/NewsList'

export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  components:
      {
        NewsList,
      },
  data:function(){return {active:0, classify:[
      {id: '21', tag_name: '热门资讯'},
      {id: '22', tag_name: '商标转让'},
      {id: '23', tag_name: '商标注册'},
      {id: '66', tag_name: '常见问题'},
      {id: '67', tag_name: '成功案例'}
    ],activeList:[],ignore_watch:false}},
  methods:{
    initPage()
    {
      //先把所有的线路拿回来
    },
    changeClassify()
    {

    },

    tabChange(ind)
    {
      // alert(ind)
    },
    goDetail: function(item)
    {
      //获得当前scroll的位置
      var sTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop;
      sessionStorage.setItem('outside_position',JSON.stringify({'scroll_y':sTop,'list':this.activeList, classify:this.classify,active:this.active}));
      location.href = item.url;
    },
    initVideo()
    {
      // video(myVideo, {
      //   //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
      //   controls: true,
      //   //自动播放属性,muted:静音播放
      //   autoplay: "muted",
      //   //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
      //   preload: "auto",
      //   //设置视频播放器的显示宽度（以像素为单位）
      //   width: "800px",
      //   //设置视频播放器的显示高度（以像素为单位）
      //   height: "400px"
      // });
    }
  },
  created:function()
  {
  },
  mounted:function(){
    this.initVideo();
  }
}
</script>

<style scoped>

.ser_text
{
  font-size: 12px;
  color: #999999;
  display: inline-block;
  width: 100%;
  text-align: center;
}

.video-item{
  position: relative;
  margin-bottom: 24px;
}
</style>

<style>
html,body{background: #f8f8f8 !important;}
html{min-height: 100%}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.disableText{color:#999999 !important;}

.in-bl{display: inline-block;}

p{font-size: 0.375rem;}
</style>
